import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Select, MenuItem, FormControl, ListItemIcon, ListItemText } from '@mui/material';
// Import flag icons
import EnglishFlag from '../assets/flags/en.svg';
import FrenchFlag from '../assets/flags/fr.svg';
import UserService from '../services/user.service';
import useApi from '../hooks/useApi';
import useAuth from "../hooks/useAuth";

const LanguageSwitcher = React.memo(() => {
  const { i18n } = useTranslation();
  const api = useApi();
  const { auth } = useAuth();

  const changeLanguage = async (event) => {
    const language = event.target.value;
    i18n.changeLanguage(language);
    
    // Update user's language preference in the database
    if (auth?.user?.id) {
      try {
        await UserService.update(auth.user.id, { language }, api);
        console.log('User language updated on server:', language);
      } catch (error) {
        console.error('Error updating user language:', error);
      }
    }
  };

  // Normalize current language to 'en' or 'fr'
  const normalizedLang = (i18n.language || '').startsWith('fr') ? 'fr' : 'en';
  
  // Determine which flag to show in the button based on the current language
  const currentFlag = normalizedLang === 'fr' ? FrenchFlag : EnglishFlag;

  return (
    <Box sx={{ minWidth: 120 }}>
      <FormControl fullWidth size="small">
        <Select
          value={normalizedLang}
          onChange={changeLanguage}
          displayEmpty
          variant="outlined"
          renderValue={() => (
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <img src={currentFlag} alt="Flag" style={{ width: 24, height: 16 }} />
              <span>{normalizedLang === 'fr' ? 'Français' : 'English'}</span>
            </Box>
          )}
          sx={{ 
            fontSize: '0.875rem',
            '& .MuiSelect-select': { py: 0.7, display: 'flex', alignItems: 'center' }
          }}
        >
          <MenuItem value="en">
            <ListItemIcon>
              <img src={EnglishFlag} alt="English Flag" style={{ width: 24, height: 16 }} />
            </ListItemIcon>
            <ListItemText>English</ListItemText>
          </MenuItem>
          <MenuItem value="fr">
            <ListItemIcon>
              <img src={FrenchFlag} alt="French Flag" style={{ width: 24, height: 16 }} />
            </ListItemIcon>
            <ListItemText>Français</ListItemText>
          </MenuItem>
        </Select>
      </FormControl>
    </Box>
  );
});

export default LanguageSwitcher;
